<template>
    <div class="wgCalcContainer">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name:'CalcContainer'
}
</script>
<style lang="scss">
.wgCalc{
    &Container{
        display: flex;
        flex-direction: column;
        background: white;
        border-radius: 20px;
        width: calc( 100% - 20px);
        max-width: 1200px;
        overflow: auto;
        box-shadow: rgb(0 0 0 / 10%) 0px 2px 20px;
        position: relative;
        max-height: none;
        min-height: 700px;
        margin: 40px auto;
        @media only screen and (min-width: 756px){
            width: 100%;

            min-height: 750px;
            max-height: 750px;
        }
    }
}

</style>
